import { render, staticRenderFns } from "./PublicCoachSideNav.vue?vue&type=template&id=67f52484&scoped=true&"
import script from "./PublicCoachSideNav.vue?vue&type=script&lang=ts&"
export * from "./PublicCoachSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./PublicCoachSideNav.vue?vue&type=style&index=0&id=67f52484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f52484",
  null
  
)

export default component.exports